export const IMAGE_SOURCE = {
    home: [
      {
        alt: 'growin-logo',
        src: require('../assets/img/growin-logo-s.png'),
      },
    ],
  };